import { createFileRoute } from "@tanstack/react-router";

import { ExperimentsView } from "../components/experiment/ExperimentsView";

export type ExperimentsSearch = {
  readonly project?: string;
  readonly experiment?: string;
};

export function validateExperimentsSearch(search: Record<string, unknown>): ExperimentsSearch {
  return {
    ...(typeof search.project === "string" && search.project.length > 0
      ? { project: search.project }
      : {}),
    ...(typeof search.experiment === "string" && search.experiment.length > 0
      ? { experiment: search.experiment }
      : {}),
  };
}

export const Route = createFileRoute("/_chat/experiments")({
  validateSearch: validateExperimentsSearch,
  component: ExperimentsView,
});
